// src/assets/categories/index.js
const categories = {
    Automobile: require('./Automobile.png'),
    Restaurant: require('./Restaurant.png'),
    Entertainment: require('./Entertainment.png'),
    // Ajoutez toutes vos catégories ici
  };
  
  export default categories;
  